import React from 'react';

export default function AccessControl() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Access Control</h1>
      <p className="text-gray-500">Halaman Access Control</p>
    </div>
  );
}
